<div class="autocont f-black roboto-l f-bmed pull-left vcenter">
  <div class="tabcell">
    Plan Actual
  </div>
</div>
<div class="basicrow m-top-ii">
  <div class="logline full"></div>
</div>
<div id="viewPlanBase" class="basicrow f-black roboto-r f-reg">
    <div class="left">
        <app-plandetail-currentplan [yz]="plan_name" [plazo_equipo]="plac_eq" [serv_ad]="add_serv"
        [valor_de_plan]="plan_val" [descr_plan]="plan_desc" [type_plan]="plan_type"
        [ins_eq]="equ_instal"></app-plandetail-currentplan>
        <div class="right">
        <app-additionals-currentplan [equ_descr]="desc_equ" [instal_equi]="equ_instal"
        [cuo_val]="quota_val" [addi_serv]="add_serv"></app-additionals-currentplan>
    </div>
  </div>
  <div class="basicrow m-top-i">
    <div class="logline full"></div>
    <div class="basicrow m-top text-center">
      <div class="servs-monthly">
        <div class="basicrow">
          <span class="roboto-b">
            Renta Mensual
          </span><br />
          <span class="f-red f-semi roboto-m">
            {{rental_value |currency }}
          </span>
        </div>
        <div class="basicrow m-top-ii boton-cambio">
          <a routerLink="/changeplan" class="btns red vcenter">
            <span class="tabcell">
              Cambiar Plan&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>